module.exports = __webpack_public_path__ + "static/media/icon-dev-ic-shopping-cart.d1efcf69.svg";